// extracted by mini-css-extract-plugin
export var categoryTitle = "prevNextArticleLinks-module--categoryTitle--d7ac0";
export var link = "prevNextArticleLinks-module--link--8857c";
export var wrapper = "prevNextArticleLinks-module--wrapper--9e98c";